import {
  makeMapStateToProps,
  mapDispatchToProps,
  StateProps,
  DispatchProps,
  ContainerProps,
} from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";
import { ComponentProps } from "./props";
import { areStatePropsEqual } from "./state-comparer";

export default withSportsbookBetslipContext(
  ({ localization, config, capabilities, balance }: SportsbookBetslipContext) => ({
    localization,
    config,
    capabilities,
    balance,
  }),
)(
  createUniversalConnector<StateProps | false, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
    { areStatePropsEqual },
  ),
);
